var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('Errors',{attrs:{"errors":_vm.errors}}),_c('h3',{staticClass:"mt-3"},[_vm._v("Deleting the contractor will delete the authorisers for the contractor as well.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }